import invoiceSearch from './invoiceSearch'
import ticketManage from './ticketManage'
import agInvoiceTemplate from './agInvoiceTemplate'
import agInvoiceSearch from './agInvoiceSearch'
import agInvoiceApply from './agInvoiceApply'
import invoiceManage from './invoiceManage'

export default [
  {
    path: '/null',
    component: () => import('@/components'),
    children: [
      ...invoiceSearch,
      ...ticketManage,
      ...agInvoiceTemplate,
      ...agInvoiceSearch,
      ...agInvoiceApply,
      ...invoiceManage
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/invoiceManage/index.js